<div class="searchable-filter-wrapper">
  <div class="filter-label">{{ label }}</div>

  <div
    class="select-container"
    [class.open]="isDropdownOpen"
    [class.disabled]="disabled"
    (click)="toggleDropdown()"
    (keydown.enter)="toggleDropdown()"
    tabindex="0"
  >
    <span [class.placeholder-text]="!filterBy">{{ selectedLabel }}</span>

    <svg
      class="chevron"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M6 8L10 12L14 8"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  </div>

  @if (isDropdownOpen) {
    <div class="dropdown-container" (appClickOutside)="onClickOutside()">
      <div class="search-wrapper">
        <svg
          class="search-icon"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 20 20"
          fill="none"
        >
          <path
            d="M14 14L18 18M16 9A7 7 0 1 1 2 9a7 7 0 0 1 14 0Z"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>

        <input
          type="text"
          placeholder="Search..."
          [(ngModel)]="searchValue"
          (input)="onSearch(searchValue)"
          (click)="$event.stopPropagation()"
        />
      </div>

      <div class="options-list">
        @if (filteredOptions.length === 0) {
          <div class="empty-state">
            {{ searchValue ? "No results found" : "No options available" }}
          </div>
        } @else {
          @for (option of filteredOptions; track option.value) {
            <div
              class="option-item"
              [class.selected]="filterBy === option.value"
              tabindex="0"
              (click)="onSelectOption(option.value); $event.stopPropagation()"
              (keydown.enter)="
                onSelectOption(option.value); $event.stopPropagation()
              "
            >
              <span class="option-text">{{ option.option }}</span>
            </div>
          }
        }
      </div>
    </div>
  }
</div>
